export default "__VITE_ASSET__Bw19NLXu__"